import { render, staticRenderFns } from "./create-new-mix.vue?vue&type=template&id=3a640606&"
import script from "./create-new-mix.vue?vue&type=script&lang=js&"
export * from "./create-new-mix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports